import React from 'react';


const FrontpageCaps = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='Screen__Start__Background'>
                {/* Atributos vitales para fondos: 
                    autoPlay: inicia solo
                    loop: se repite infinitamente
                    muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                    playsInline: previene que en iOS el video se abra a pantalla completa
                */}
                {isActiveWomensMode ? (
                    <img src="/img/page/backgrounds/background-womens-day-2026.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )}
            </div>

            <div className="caps-intro">
                
                {/* Contenedor de Logos y Título */}
                <div className="caps-intro__logo-container">
                    <div className='d-flex align-items-center justify-content-center'>
                        <img src="/img/page/xolos-five.png" className="caps-intro__logo" alt="Patrocinador Central" />
                    </div>
                    
                    <p className="caps-intro__text text-uppercase fw-bold mt-4">Presentan</p>
                    <p className="caps-intro__title text-uppercase fw-black">Encuentra el balón</p>
                </div>

                {/* La gorra animada que flota en el centro */}
                <div className='d-flex align-items-center justify-content-center'>
                    <img src="/img/games/caps/cap.png" className="caps-intro__hero" alt="Gorra Misteriosa" />
                </div>

                {/* Footer de Créditos */}
                <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px' }}>Hecho con ♥ por Interaktia | 2026</p>
            </div>
        </>
    );
};

export { FrontpageCaps };